<template>
  <VApp>
    <RouterView />
    <ApolloSyncSnackbar />
  </VApp>
</template>

<script setup>
  import { defineComponent } from "vue";
  import ApolloSyncSnackbar from "@/components/ApolloSyncSnackbar.vue";

  defineComponent({
    name: "App",
  });
</script>
